import styled from 'styled-components';

import { colors, radii, shadows } from '@gbs-monorepo-packages/styles';

export const Page = styled.div`
  background-color: ${colors.authPagesBackground};
  box-sizing: border-box;
  min-height: 100vh;
  padding: 1.5rem 1rem 3rem;
`;

export const Article = styled.article`
  background-color: ${colors.white300};
  border-radius: ${radii.lg};
  box-shadow: ${shadows.modal};
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 48rem;
  padding: 1.75rem 1.5rem 2.5rem;
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 1.375rem;
  line-height: 1.35;
  margin: 0 0 1.25rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1rem;
  line-height: 1.4;
  margin: 1.5rem 0 0.5rem;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const Paragraph = styled.p`
  color: ${colors.text};
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 0 0 0.75rem;
`;

export const List = styled.ul`
  color: ${colors.text};
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 0 0 0.75rem;
  padding-left: 1.25rem;
`;

export const ListItem = styled.li`
  margin-bottom: 0.35rem;
`;

export const ExternalLink = styled.a`
  color: ${colors.authPagesLink};
  font-weight: 600;
  text-decoration: none;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
  }
`;

export const LeadLabel = styled.span`
  font-weight: 600;
`;
